import React from 'react';
import styled from 'styled-components';

const StyledScrollIndicator = styled.div`
  position: absolute;
  bottom: 40px;
  left: 50%;
  transform: translateX(-50%);
  cursor: pointer;
  z-index: 2;
  
  .scroll-arrow {
    width: 30px;
    height: 50px;
    border: 2px solid #51c2c9;
    border-radius: 25px;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      top: 10px;
      left: 50%;
      width: 6px;
      height: 6px;
      background: #51c2c9;
      border-radius: 50%;
      transform: translateX(-50%);
      animation: scroll 2s infinite;
    }
  }
  
  @keyframes scroll {
    0% { transform: translateX(-50%) translateY(0); opacity: 1; }
    100% { transform: translateX(-50%) translateY(20px); opacity: 0; }
  }
`;

interface ScrollIndicatorProps {
  onClick?: () => void;
}

const ScrollIndicator: React.FC<ScrollIndicatorProps> = ({ onClick }) => {
  return (
    <StyledScrollIndicator onClick={onClick}>
      <div className="scroll-arrow"></div>
    </StyledScrollIndicator>
  );
};

export default ScrollIndicator;

